import { render, staticRenderFns } from "./jgPolicyCom.vue?vue&type=template&id=1797db22&"
import script from "./jgPolicyCom.vue?vue&type=script&lang=ts&"
export * from "./jgPolicyCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports